module.exports = __webpack_public_path__ + "img/vue-composition-api-logo.768f1ab1.jpg";